const RAZORPAY_SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

export function loadRazorpayCheckout() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Razorpay is only available in the browser."));
  }
  if (window.Razorpay) {
    return Promise.resolve(window.Razorpay);
  }

  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${RAZORPAY_SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => {
        if (window.Razorpay) resolve(window.Razorpay);
        else reject(new Error("Razorpay failed to load."));
      });
      existing.addEventListener("error", () => reject(new Error("Razorpay failed to load.")));
      return;
    }

    const script = document.createElement("script");
    script.src = RAZORPAY_SCRIPT_SRC;
    script.async = true;
    script.onload = () => {
      if (window.Razorpay) resolve(window.Razorpay);
      else reject(new Error("Razorpay failed to load."));
    };
    script.onerror = () => reject(new Error("Razorpay failed to load."));
    document.body.appendChild(script);
  });
}

export function openRazorpayCheckout({
  keyId,
  orderId,
  amount,
  currency = "INR",
  name = "Yoga Retreats Booking",
  description,
  prefill,
  onSuccess,
  onDismiss,
}) {
  return loadRazorpayCheckout().then((Razorpay) => {
    const rzp = new Razorpay({
      key: keyId,
      amount,
      currency,
      order_id: orderId,
      name,
      description: description || "Retreat booking",
      prefill: prefill || {},
      theme: { color: "#059669" },
      handler: (response) => {
        if (typeof onSuccess === "function") onSuccess(response);
      },
      modal: {
        ondismiss: () => {
          if (typeof onDismiss === "function") onDismiss();
        },
      },
    });
    rzp.open();
    return rzp;
  });
}
